import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkboxes } from '../../../FlowConfigurationInputs';

function CreateUser({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.';
    const options = {
        checkboxes: { label: label + 'ISDISABLE' }
    }
    useEffect(() => {
        if (!action.fields.userName) {
            action.fields.userName = { value: '', isRequired: true }
        }
        if (!action.fields.logonName) {
            action.fields.logonName = { value: '', isRequired: true }
        }
        if (!action.fields.firstName) {
            action.fields.firstName = { value: '', isRequired: true }
        }
        if (!action.fields.lastName) {
            action.fields.lastName = { value: '', isRequired: true }
        }
    }, [action.fields]);

    return (
        <div>
            <div className="form-element">
                {t(label + 'USERNAME')}
                <TextInput action={action} inputName="userName" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} fieldType={"string"} displayName={t(label + 'USERNAME')} />
            </div>
            <div className="form-element">
                {t(label + 'LOGON-NAME')}
                <TextInput action={action} inputName="logonName" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} fieldType={"string"} displayName={t(label + 'LOGON-NAME')} />
            </div>
            <div className="form-element">
                {t(label + 'FIRST-NAME')}
                <TextInput action={action} inputName="firstName" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} fieldType={"string"} displayName={t(label + 'FIRST-NAME')} />
            </div>
            <div className="form-element">
                {t(label + 'LAST-NAME')}
                <TextInput action={action} inputName="lastName" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} fieldType={"string"} displayName={t(label + 'LAST-NAME')} />
            </div>
            <div className="form-element">
                {t(label + 'DISPLAY-NAME')}
                <TextInput action={action} inputName="displayName" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DISPLAY-NAME')} />
            </div>
            <div className="form-element">
            {t(label + 'DISTINGUISH-NAME')}
                <TextInput action={action} inputName="distinquishName" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DISTINGUISH-NAME')} />
            </div>
            <div className="form-element">
                {t(label + 'EMAIL')}
                <TextInput action={action} inputName="email" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} inputMode="email" fieldType={"string"} displayName={t(label + 'EMAIL')} />
            </div>
            <div className="form-element">
                {t(label + 'PASSWORD')}
                <TextInput action={action} inputName="password" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'PASSWORD')} />
            </div>
            <div className="form-element">
                {t(label + 'DESCRIPTION')}
                <TextInput action={action} inputName="description" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DESCRIPTION')} />
            </div>
            <div className="form-element">
                {t(label + 'DEPARTMENT')}
                <TextInput action={action} inputName="department" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DEPARTMENT')} />
            </div>
            <div className="form-element">
                {t(label + 'TITLE')}
                <TextInput action={action} inputName="title" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'TITLE')} />
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="disableUser" options={options.checkboxes} />
            </div>
        </div>
    )
}

export default CreateUser;